import { useEffect, useState } from 'react';
import TableWrapper from '../shared/table';
import { dataTypes } from '../shared/table-helpers';

export function VendorWarehouseTable({ data }) {
  const [vendorWarehouseItems, setVendorWarehouseItems] = useState(data);

  useEffect(() => {
    setVendorWarehouseItems(data);
  }, [data]);

  const externalHeaderContent = () => {
    const columns = vendorWarehouseItems[0]
      ? Object.keys(vendorWarehouseItems[0]).map((key) => {
          return {
            id: key,
            label: key.replace(/_/g, ' '),
            dataTypes:
              key === 'container_item_id' ? dataTypes.itemId : dataTypes.string,
            isSortable: true,
          };
        })
      : [];
    return columns;
  };

  return vendorWarehouseItems?.length ? (
    <TableWrapper
      style={{ height: '750px' }}
      gridStyle={{
        rowSpacing: 0,
        spacing: 0,
        sx: { margin: 0, width: '100%' },
      }}
      columns={externalHeaderContent()}
      rows={vendorWarehouseItems}
      transformRows
      showFilter
      showSearch
    />
  ) : (
    <div>No Vendor Warehouse Items Found</div>
  );
}
